import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import axios from "axios";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const OrderSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const user = useSelector((state) => state?.user?.data[0]);

  const search = new URLSearchParams(location.search);
  const paymentKey = search.get("paymentKey");
  const orderId = search.get("orderId");
  const amount = search.get("amount");

  const orderRequestedRef = useRef(false);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!paymentKey || !orderId || !amount) {
      toast.error("결제 정보가 유효하지 않습니다.");
      navigate("/shop");
      return;
    }

    if (!orderRequestedRef.current) {
      orderRequestedRef.current = true;
      confirmPayment();
    }
  }, []);

  const calcProductTotal = (p) => {
    const base = p.unitPrice || p.productPrice || 0;
    const quantity = p.quantity || 1;
    const optionTotal = (p.options || []).reduce(
      (sum, opt) => sum + (opt.addPrice ?? opt.price ?? 0) * (opt.quantity ?? opt.qty ?? 1),
      0,
    );
    return (base + optionTotal) * quantity;
  };

  const confirmPayment = async () => {
    try {
      const orderItems = JSON.parse(sessionStorage.getItem("orderItems") || "[]");
      const address = JSON.parse(sessionStorage.getItem("orderAddress") || "{}");
      const paymentMethod = sessionStorage.getItem("paymentMethod") || "CARD";

      await createOrder({ paymentKey, orderId, amount, orderItems, address, paymentMethod });
    } catch (err) {
      console.error(err);
      toast.error("주문 처리 실패");
      navigate("/shop");
    } finally {
      setLoading(false);
    }
  };

  const createOrder = async ({
    paymentKey,
    orderId,
    amount,
    orderItems,
    address,
    paymentMethod,
  }) => {
    const totalPrice = orderItems.reduce((acc, group) => {
      const groupTotal = group.products.reduce((sum, p) => sum + calcProductTotal(p), 0);
      return acc + groupTotal;
    }, 0);

    const input = {
      mberNo: user?.mberNo || 0,
      mberNm: user?.name || "",
      mberTel: user?.moblphonNo || "",
      platform: "MULTI_PAGE",
      receiverName: address?.recipientName || user?.mberNm || "수령인",
      receiverTel: address?.phone || user?.mberTel || "000-0000-0000",
      postalCode: address?.postcode || "",
      address: address?.address || "",
      addressDetail: address?.detailAddress || "",
      memo: address?.memo || "",
      totalPrice,
      discount: 0,
      deliveryFee: 3000,
      finalPrice: Number(amount),
      paymentMethod,
      transactionId: paymentKey,
      paymentCond: {
        paymentKey,
        orderID: orderId,
        amount: amount.toString(),
      },
      subOrders: orderItems.map((group) => {
        const groupTotal = group.products.reduce((sum, p) => sum + calcProductTotal(p), 0);
        return {
          cmpnyNo: group.cmpnyNo || 0,
          cmpnyName: group.cmpnyNm || "",
          totalPrice: groupTotal,
          discount: 0,
          deliveryFee: 3000,
          feeAmount: 0,
          settlementAmount: groupTotal,
          products: group.products.map((p) => ({
            productId: p.vendorProductId ?? 0,
            productName: p.productName || "",
            brand: p.brand || "",
            quantity: p.quantity || 1,
            unitPrice: p.productPrice || 0,
            discount: 0,
            totalPrice: calcProductTotal(p),
            options: (p.options || []).map((o) => ({
              optionId: o.id ?? 0,
              optionGroupName: o.optionGroupName || "",
              optionValue: o.name || "",
              addPrice: o.price ?? o.price ?? 0,
              quantity: o.qty ?? o.qty ?? 1,
            })),
          })),
        };
      }),
    };

    try {
      const url = "/erp/customerOrder/create";
      const body = { input };
      const res = await axios.post(url, body);

      const success = res.data?.orderId;
      if (success) {
        toast.success("주문이 완료되었습니다.");
        sessionStorage.removeItem("orderItems");
        sessionStorage.removeItem("orderAddress");
        sessionStorage.removeItem("paymentMethod");
        navigate("/shop/mypage/history");
      } else {
        toast.error("주문 처리 중 문제가 발생했습니다.");
        navigate("/shop/mypage/cart");
      }
    } catch (err) {
      console.error(err);
      toast.error("일시적인 오류로 주문에 실패했습니다. 잠시 후 다시 시도해주세요.");
      navigate("/shop/mypage/cart");
    } finally {
      setLoading(false);
    }
  };

  return <div>{loading ? "주문 처리 중입니다..." : "처리 완료"}</div>;
};

export default OrderSuccess;
